import AppHeaderTitle, { AppHeaderTitleProps } from './AppHeaderTitle';

export default AppHeaderTitle;
export type { AppHeaderTitleProps };
